<template>
	<localizer>
		<div class="app">
			<AppHeader fixed @updatingLocale="updatingLocale" :locale="locale" v-if="!isLogout">
				<SidebarToggler class="d-lg-none" display="md" mobile />
				<b-link class="navbar-brand" to="#">
					<img
						class="navbar-brand-full"
						src="img/brand/logo.svg"
						width="89"
						height="25"
						alt="CoreUI Logo"
					/>
					<img
						class="navbar-brand-minimized"
						src="img/brand/sygnet.svg"
						width="30"
						height="30"
						alt="CoreUI Logo"
					/>
				</b-link>
				<SidebarToggler class="d-md-down-none" display="lg" />
				<b-navbar-nav class="d-md-down-none">
					<b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
					<b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
					<b-nav-item class="px-3">Settings</b-nav-item>
				</b-navbar-nav>
				<b-navbar-nav class="ml-auto">
					<b-nav-item class="d-md-down-none">
						<i class="icon-bell"></i>
						<b-badge pill variant="danger">5</b-badge>
					</b-nav-item>
					<b-nav-item class="d-md-down-none">
						<i class="icon-list"></i>
					</b-nav-item>
					<b-nav-item class="d-md-down-none">
						<i class="icon-location-pin"></i>
					</b-nav-item>
					<DefaultHeaderDropdownAccnt />
				</b-navbar-nav>
				<AsideToggler class="d-none d-lg-block" />
				<!--<AsideToggler class="d-lg-none" mobile />-->
			</AppHeader>

			<!-- <AppHeader /> -->

			<div class="app-body" :style="hidePageMainInfo ? 'margin: 0;' : ''">
				<Sidebar :navItems="nav" v-if="!isLogout" />
				<main class="main" :style="hidePageMainInfo ? 'margin: 0;' : ''">
					<breadcrumbV2 v-if="!isLogout">
						<div class="container-fluid">
							<b-alert variant="danger" dismissible :show="!!$root.msg_error" id="msg_error">
								<button type="button" aria-label="Close" class="close" @click="$root.msg_error = false">×</button>
								<div v-html="$root.msg_error"></div>
							</b-alert>
							<router-view></router-view>
						</div>
					</breadcrumbV2>
				</main>
				<AppAside v-if="!isLogout" />
			</div>
			<AppFooter v-if="!isLogout" />
		</div>
	</localizer>
</template>

<script>
	import Cookies from 'js-cookie'
	import nav from '../_nav'
	import {
		Header as AppHeader,
		Sidebar,
		Aside as AppAside,
		Footer as AppFooter,
		BreadcrumbV2,
		Localizer,
	} from '../components/'
	export default {
		name: 'full',
		components: {
			AppHeader,
			Sidebar,
			AppAside,
			AppFooter,
			BreadcrumbV2,
			Localizer,
		},
		data() {
			return {
				nav: nav.items,
				locale: Cookies.get('_al') || 'en',
			}
		},
		computed: {
			name() {
				return this.$route.name
			},
			list() {
				return this.$route.matched
			},
			hidePageMainInfo() {
				return !(['Login', 'Register', 'Logout'].indexOf(this.$route.name) === -1)
			},
			isLogout() {
				return !(['Logout'].indexOf(this.$route.name) === -1)
			},
		},
		methods: {
			updatingLocale(lang) {
				this.locale = lang.code
			},
		},

		created() {},

		mounted() {},
	}
</script>
